import { ACTION_TYPES, Actions } from "./types"
import { Action } from "./actions"

export const INVENTORY_CONFIGURATION_ACTION_TYPES = ACTION_TYPES
export const InventoryConfigurationAction = Action
export type InventoryConfigurationActions = Actions




// WEBPACK FOOTER //
// ./src/state/inventory/configuration/actions/index.ts